/**
 * Elfesoul - 购物车自定义业务逻辑
 * 专门处理多阶梯促销、专属优惠动态计算等交互
 */
window.ElfesoulCartDrawer = {
  // 初始化或重置促销消息
  initPromoMessage: function(container) {
    // 限制在传入的购物车容器内寻找，避免全局交叉污染
    const promoSpan = container ? container.querySelector('#elfesoul-promo-message') : document.querySelector('#elfesoul-promo-message');
    if (!promoSpan) return;

    // 1. 如果购物车是空的，保持智能计算等待动画
    const isCartEmpty = container && container.classList.contains('is-empty');
    if (isCartEmpty) {
      promoSpan.innerHTML = 'Calculating your exclusive rewards<span class="dots">...</span>';
      promoSpan.style.opacity = '0.7';
      return;
    }

    // 2. 如果购物车内有商品，在打开或更新数量时触发平滑过渡动效
    promoSpan.style.transition = 'opacity 0.3s ease';
    promoSpan.style.opacity = '0.5';

    setTimeout(() => {
      promoSpan.style.opacity = '1';
    }, 200);
  }
};